import type { InputHTMLAttributes, ReactNode } from "react";
/** Radio del sistema (control propio; nativo oculto, sk-box lo pinta). */
export function Radio({ label, help, ...input }: { label: ReactNode; help?: ReactNode | undefined } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className="sk-radio">
      <input type="radio" {...input} />
      <span className="sk-box" />
      <span>{label}{help !== undefined && <span className="sk-help" style={{ display: "block" }}>{help}</span>}</span>
    </label>
  );
}
